import React from "react";
import { IonToast } from "@ionic/react";
import { useOrgSharingContext } from "./OrgSharingContext";
import { MyOrgRelationshipCardsView } from "./MyOrgRelationshipCards";
import { UseMyOrgRelationship } from "./useMyOrgRelationship";
import { relationshipCards } from "../../../services/orgRelationship";
import "./ShareOrgs.css";

// The "Organizations" part of the Data Sharing screen: the patient's HME relationship cards
// (ACDPA-315 / D77) and the org toast, which every org surface shares via OrgSharingContext.
//
// F-507 (owner ruling 2026-09-29, with F-506): the "Did you know?" card and its own "Share with an
// organization" button are gone, in every state. The screen's ONE "Share my data" button asks
// person or organization instead (ShareDataChooser). With the card gone the section heading only
// shows when there is a relationship card under it.
//
// F-523 (UAT, URS_5.5, preview-101): the "Your equipment provider" (association) card is gone
// too — `MyOrgRelationshipCardsView` renders only the invitation card now — so the heading is
// gated on `showInvitation` alone; a lingering `showAssociation` would float this heading over
// nothing.
type Props = {
  /** F-492 — the screen's ONE relationship hook, shared with the X on "Who can see my data". */
  rel: UseMyOrgRelationship;
};

const ShareOrgsSection: React.FC<Props> = ({ rel }) => {
  const { toast, setToast, reload } = useOrgSharingContext();
  const { showInvitation } = relationshipCards(rel);
  const hasCards = !rel.loading && showInvitation;

  return (
    <>
      {hasCards && (
        <p id="data-sharing-orgs-title" className="sub-section-title">
          Organizations
        </p>
      )}
      <MyOrgRelationshipCardsView rel={rel} onChanged={reload} />
      <IonToast
        isOpen={!!toast}
        message={toast}
        duration={2500}
        onDidDismiss={() => setToast("")}
      />
    </>
  );
};

export default ShareOrgsSection;
